import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major" >
        <div className="inner">
            <header className="major">
                <h1>Hi, I am Sierra</h1>
            </header>
            <div className="content">
                <p>Up and coming full-stack developer with strong design instincts </p>
                {/* <ul className="actions">
                    <li><a href="#one" className="button next scrolly">Get Started</a></li>
                </ul> */}
            </div>
        </div>
    </section>
)

export default Banner
